// Import all metadata files directly from src/data
import moisesdb_eg01_metadata from './data/moisesdb_eg01_metadata.json';
import moisesdb_eg02_metadata from './data/moisesdb_eg02_metadata.json';
import moisesdb_eg03_metadata from './data/moisesdb_eg03_metadata.json';
import moisesdb_eg04_metadata from './data/moisesdb_eg04_metadata.json';
import moisesdb_eg05_metadata from './data/moisesdb_eg05_metadata.json';
import musdb_eg01_metadata from './data/musdb_eg01_metadata.json';
import musdb_eg02_metadata from './data/musdb_eg02_metadata.json';
import musdb_eg03_metadata from './data/musdb_eg03_metadata.json';
import musdb_eg04_metadata from './data/musdb_eg04_metadata.json';
import musdb_eg05_metadata from './data/musdb_eg05_metadata.json';

// Table 1 Main Ablation Data Structure
export const table1Examples = [
    // MoisesDB examples
    {
        id: 'moisesdb_eg01',
        dataset: 'MoisesDB',
        name: 'eg01_0547_ebea0f1d_seg04',
        displayName: 'Set 01',
        metadata: moisesdb_eg01_metadata
    },
    {
        id: 'moisesdb_eg02',
        dataset: 'MoisesDB',
        name: 'eg02_0360_72c6f013_seg07',
        displayName: 'Set 02',
        metadata: moisesdb_eg02_metadata
    },
    {
        id: 'moisesdb_eg03',
        dataset: 'MoisesDB',
        name: 'eg03_1071_3c557409_seg09',
        displayName: 'Set 03',
        metadata: moisesdb_eg03_metadata
    },
    {
        id: 'moisesdb_eg04',
        dataset: 'MoisesDB',
        name: 'eg04_0972_93dda0e8_seg04',
        displayName: 'Set 04',
        metadata: moisesdb_eg04_metadata
    },
    {
        id: 'moisesdb_eg05',
        dataset: 'MoisesDB',
        name: 'eg05_0824_312bec8d_seg02',
        displayName: 'Set 05',
        metadata: moisesdb_eg05_metadata
    },
    // MusDB examples
    {
        id: 'musdb_eg01',
        dataset: 'MusDB',
        name: 'eg01_0017_Music_Delta__Gospel_seg00',
        displayName: 'Set 01',
        metadata: musdb_eg01_metadata
    },
    {
        id: 'musdb_eg02',
        dataset: 'MusDB',
        name: 'eg02_0946_Bobby_Nobody__Stitch_Up_seg02',
        displayName: 'Set 02',
        metadata: musdb_eg02_metadata
    },
    {
        id: 'musdb_eg03',
        dataset: 'MusDB',
        name: 'eg03_0314_Celestial_Shore__Die_For_Us_seg04',
        displayName: 'Set 03',
        metadata: musdb_eg03_metadata
    },
    {
        id: 'musdb_eg04',
        dataset: 'MusDB',
        name: 'eg04_0045_ANiMAL__Clinic_A_seg05',
        displayName: 'Set 04',
        metadata: musdb_eg04_metadata
    },
    {
        id: 'musdb_eg05',
        dataset: 'MusDB',
        name: 'eg05_0117_Al_James__Schoolboy_Facination_seg02',
        displayName: 'Set 05',
        metadata: musdb_eg05_metadata
    }
];

export const modelConfigs = [
    {
        id: 'model_C_ii',
        displayName: 'C-(ii)',
        description: 'Full model (our approach)',
        color: '#fff9e6'
    },
    {
        id: 'model_B_ii',
        displayName: 'B-(ii)',
        description: 'With data grouping, with noise sharing',
        color: '#f0f9f0'
    },
    {
        id: 'model_B_i',
        displayName: 'B-(i)',
        description: 'With data grouping, no noise sharing',
        color: '#f7f0f0'
    },
    {
        id: 'model_A_ii',
        displayName: 'A-(ii)',
        description: 'No data grouping, with noise sharing',
        color: '#f0f4f8'
    },
    {
        id: 'model_A_i',
        displayName: 'A-(i)',
        description: 'No data grouping, no noise sharing',
        color: '#f7f3e9'
    }
];

// Helper functions
export const getAudioPath = (example, modelId, stemIndex = null) => {
    const datasetFolder = example.dataset.toLowerCase() === 'moisesdb' ? 'moisesdb_from_scratch' : 'musdb_from_scratch';
    const basePath = `${process.env.PUBLIC_URL || ''}/audio/table01/${datasetFolder}/${example.name}/${modelId}`;

    if (stemIndex !== null) {
        // Individual stem audio
        return `${basePath}/${stemIndex}/output.mp3`;
    } else {
        // Mixed audio
        return `${basePath}/output_mix.mp3`;
    }
};

export const loadExampleMetadata = (example) => {
    try {
        console.log('Loading metadata for example:', example.name);
        const metadata = example.metadata;

        if (!metadata) {
            console.error('No metadata found for example:', example.name);
            return null;
        }

        // Parse the stems array - it's stored as a Python string representation
        // Format: "['VOCALS' 'BASSES' 'GUITARS' 'KEYS' 'DRUMS']"
        let allStems = [];
        try {
            // Convert Python list format to JSON format
            // Format: "['VOCALS' 'BASSES' 'GUITARS' 'KEYS' 'DRUMS']"
            let stemsStr = metadata.all_stems.trim();

            // Remove outer brackets if present
            if (stemsStr.startsWith('[') && stemsStr.endsWith(']')) {
                stemsStr = stemsStr.slice(1, -1);
            }

            // Split by spaces and filter out empty strings
            const stemItems = stemsStr.split(/\s+/).filter(item => item.length > 0);

            // Clean each item (remove quotes) and create proper JSON array
            const cleanedStems = stemItems.map(item => item.replace(/^['"]|['"]$/g, ''));

            allStems = cleanedStems;
        } catch (parseError) {
            console.warn('Failed to parse all_stems:', parseError);
            console.warn('Raw all_stems value:', metadata.all_stems);
            // Fallback: extract unique stems from the mapping
            if (metadata.subdir_output_stems) {
                allStems = [...new Set(Object.values(metadata.subdir_output_stems))];
                console.log('Using fallback stems from subdir_output_stems:', allStems);
            } else {
                console.error('No subdir_output_stems available for fallback');
                allStems = [];
            }
        }

        const stemMapping = metadata.subdir_output_stems;

        // Create ordered list of stems with their folder mappings
        let orderedStems = [];
        if (stemMapping && typeof stemMapping === 'object') {
            orderedStems = Object.entries(stemMapping)
                .sort(([folderA], [folderB]) => {
                    const indexA = parseInt(folderA.split('_')[0]);
                    const indexB = parseInt(folderB.split('_')[0]);
                    return indexA - indexB;
                })
                .map(([folder, stemType]) => ({
                    folder,
                    stemType,
                    index: parseInt(folder.split('_')[0])
                }));
        } else {
            console.error('Invalid or missing subdir_output_stems in metadata');
        }

        console.log('Successfully processed metadata for:', example.name);
        return {
            ...metadata,
            orderedStems,
            allStems
        };

    } catch (error) {
        console.error('Failed to process metadata for', example.name, error);
        return null;
    }
};
